import React, { useState, useRef, useEffect } from 'react';
import { ApiCore } from '../../../api/index';
import { Tabs, Toast } from 'antd-mobile-v5';
import { withRouter } from 'react-router-dom';
import NoInventory from '../../component/noInventory';
import styles from './index.module.scss';
import Medicine from '../../../static/images_cso/prescription_icon.png';
import right_arrow from '../../../static/images_cso/right_arrow.png';

const api = new ApiCore();

const MoreCureSuggest = (props: any) => {

    const [list, setList] = useState<any>([]);
    const [doctorInfo, setDoctorInfo] = useState<any>({});
    const [activeKey, setActiveKey] = useState('all');
    const [projects, setProjects] = useState<any>([]);
    const [project, setProject] = useState<any>({});
    const noInventoryRef = useRef<any>();

    useEffect(() => {
        let doctor_info = sessionStorage.getItem('cso_doctor_info') || '{}';
        const doctorInfo: any = JSON.parse(doctor_info);
        setDoctorInfo(doctorInfo);
        setProjects(doctorInfo.projects);
        getInfo().then((data: any) => {
            setList(data);
        });
        return () => {
        }
    }, [])

    const getInfo = () => {
        return new Promise<any>((resolve) => {
            api.getPlanList({}).then((res: any) => {
                if (res.code == 0) {
                    const _data = res.data || {};
                    resolve(_data);
                }
            });
        });
    }

    const itemClick = async (val: any) => {
        const params = {
            code: val.code
        }
        const medicineRes: any = await api.getPlanDetail(params);
        if (medicineRes.code == 0) {
            props.history.push(`/cso/doctor/covidSuggest?code=${val.code}&name=${encodeURIComponent(val.title.substr(0, 2))}`);
        } else if (medicineRes.code == 70010100) {
            // 70010100 -> 暂无推荐的药品！
            noInventoryRef.current.toShow();
        } else {
            Toast.show(medicineRes.message);
        }
    }

    return (
        <div className={styles.more_cure_content}>
            <div className={styles.customHeader}>
                <Tabs
                    className={styles.tabs}
                    activeLineMode='fixed'
                    style={{
                    '--fixed-active-line-width': '20px',
                    '--active-line-color': '#13598C',
                    }}
                    onChange={(key: any) => {
                        setActiveKey(key)
                        key !== 'all' && setProject(projects.find((v: any) => v.code == key))
                    }}
                >

                    <Tabs.Tab title='全部' key='all'>
                        {
                            list && list.map((val: any, key: number) => (
                                <div key={key} className={styles.suggestion}>
                                    <div className={styles.s_l} onClick={() => { itemClick(val) }} >
                                        <img className={styles.item_icon} src={Medicine} alt="" />
                                        <div>
                                            <div>{val.title}</div>
                                            <div> 
                                                <div>{val.remark}</div> 
                                            </div>
                                            <div>
                                                <div>推荐：{val.num ? val.num : 0}</div>
                                                {/* <div>购买：12</div> */}
                                            </div>
                                        </div>
                                        <img className={styles.s_l_icon} src={right_arrow} alt="" />
                                    </div>
                                </div>
                            ))
                        }
                    </Tabs.Tab>
                    {
                        projects.map((val: any, key: number) => (
                            <Tabs.Tab title={val.shortName} key={val.code}>
                                {
                                    list && list.map((val: any, key: number) => (
                                        <div key={key} className={styles.suggestion}>
                                            <div className={styles.s_l} onClick={() => { itemClick(val) }} >
                                                <img className={styles.item_icon} src={Medicine} alt="" />
                                                <div>
                                                    <div>{val.title}</div>
                                                    <div> 
                                                        <div>{val.remark}</div> 
                                                    </div>
                                                    <div>
                                                        <div>推荐：{val.num ? val.num : 0}</div>
                                                        {/* <div>购买：12</div> */}
                                                    </div>
                                                </div>
                                                <img className={styles.s_l_icon} src={right_arrow} alt="" />
                                            </div>
                                        </div>
                                    ))
                                }
                            </Tabs.Tab>
                        ))
                    }
                    <Tabs.Tab title='' key='1'></Tabs.Tab>
                    <Tabs.Tab title='' key='2'></Tabs.Tab>
                    <Tabs.Tab title='' key='3'></Tabs.Tab>
                    <Tabs.Tab title='' key='4'></Tabs.Tab>
                    <Tabs.Tab title='' key='5'></Tabs.Tab>
                </Tabs>

                {/* <img className={styles.moreIcon} src={DoctorAvatar}  /> */}
            </div>
            <NoInventory ref={noInventoryRef}></NoInventory>
        </div>
    )
}

export default withRouter(MoreCureSuggest);